import React, { useState } from "react";
import { BurialPlotsModal } from "./burialPlotsModal";
import { ReactComponent as AddIcon } from "assets/bruial/addIcon.svg";
import { ReactComponent as SmallAddIcon } from "assets/bruial/smallAddIcon.svg";
import { ReactComponent as DetailArrowIcon } from "assets/bruial/detailArrowIcon.svg";
import type { IBurialAdd } from "service/interface/burial";

interface Props {
  data: IBurialAdd;
  setData: React.Dispatch<React.SetStateAction<IBurialAdd>>;
}

export function BurialPlotsTable({ data, setData }: Props) {
  const [isBurialPlotsModalVisible, setIsBurialPlotsModalVisible] =
    useState<boolean>(false);
  const [selectDetail, setSelectDetail] = useState<string>("");

  const handleAddBtn = () => {
    setSelectDetail("");
    setIsBurialPlotsModalVisible(true);
  };

  const handleSelectDetail = (idx: number) => {
    setSelectDetail(idx + "");
    setIsBurialPlotsModalVisible(true);
  };

  const handleDeletePlot = (idx: number) => {
    let copiedArr = data.BurialPlots;
    copiedArr.splice(idx, 1);
    setData((prev) => ({
      ...prev,
      BurialPlots: copiedArr,
    }));
  };

  return (
    <>
      <BurialPlotsModal
        isVisible={isBurialPlotsModalVisible}
        setIsVisible={setIsBurialPlotsModalVisible}
        data={data}
        setData={setData}
        selectIdx={selectDetail}
      />
      <div className="mb-[64px]">
        <div className="mb-[16px] flex items-center justify-between">
          <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
            시설 사용료 정보
          </p>
          {data.BurialPlots.length !== 0 && (
            <div
              className="flex cursor-pointer items-center gap-[4px]"
              onClick={handleAddBtn}
            >
              <SmallAddIcon />
              <p className="m-0 text-[18px] font-semibold text-black">
                추가하기
              </p>
            </div>
          )}
        </div>
        <div className="w-full border-t-[2px] border-t-black p-0">
          {data.BurialPlots.length !== 0 ? (
            <div className="mt-[24px] flex w-full flex-col gap-[20px]">
              {data.BurialPlots.map((plot, idx) => (
                <div key={idx} className="flex items-center gap-[20px]">
                  <div
                    onClick={() => handleSelectDetail(idx)}
                    className="flex h-[62px] w-[calc(100%-52px)] cursor-pointer items-center justify-between rounded-[8px] border-[1px] border-black px-[16px]"
                  >
                    <p className="m-0 text-[18px] font-semibold">
                      {plot.name}/{plot.BurialPlotTypes[0].name}/
                      {plot.BurialPlotTypes[0].BurialPlotTypeDetails[0].name}
                    </p>
                    <DetailArrowIcon />
                  </div>
                  <div
                    onClick={() => handleDeletePlot(idx)}
                    className="flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-full bg-gray-5 text-[18px] font-semibold text-white"
                  >
                    X
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              onClick={handleAddBtn}
              className="mt-[24px] flex h-[150px] w-full cursor-pointer flex-col items-center justify-center gap-[16px] rounded-[16px] border-[2px] border-dashed border-[#d1d1d1] bg-[#f8f8f8]"
            >
              <AddIcon />
              <p className="m-0 text-M3 font-semibold text-black">
                시설 정보 추가하기
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
